<template>
  <div v-if="company" class="navbar-mobile" :style="'--highlight-color: '+ company.highlight +';'">
    <!-- menu -->
    <button @click="toggleNav" class="navbar-mobile__button">
      <i class="hamburger"></i> <span>Valikko</span>
    </button>
    <transition name="slide-left">
      <div v-if="isOpen" class="navbar-mobile__menu">
        <button @click="toggleNav" class="navbar-mobile__close-button">
          <i class="close"></i> <span>Sulje</span>
        </button>
        <ul>
          <router-link tag="li" to="/"><a>Vuosikello</a></router-link>
          <router-link tag="li" :to="{ name: 'Admin' }">
            <a>Hallinta</a>
          </router-link>
        </ul>
        <div class="navbar-mobile__categories"></div>
      </div>
    </transition>
    <!-- user-menu -->
    <button @click="toggleUserNav" class="navbar-mobile__user-button">
      <span
        class="navbar-mobile__user-logo"
        :style="{ backgroundImage: `url(${logo})` }"
      ></span>
    </button>
    <transition name="slide-right">
      <div v-if="userIsOpen" class="navbar-mobile__user-menu">
        <ul>
          <li><a @click="logout">Kirjaudu ulos</a></li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import firebase from "firebase";
import db from "@/firebase/init";
import { mapState } from "vuex";

export default {
  name: "MobileNavbar",
  data() {
    return {
      isOpen: false,
      userIsOpen: false,
      logo: null,
      name: null,
      companyId: null
    };
  },
  computed: {
    ...mapState(["company"])
  },
  watch: {
    $route() {
      this.isOpen = false;
    }
  },
  created() {
    let user = firebase.auth().currentUser;
    if(user == null) {
      return;
    }
    
    db.collection("users")
      .doc(user.uid)
      .get()
      .then(doc => {
        let data = doc.data();
        this.name = data.username;
        this.companyId = data.companyId;
      })
      .then(() => {
        db.collection("companies")
          .doc(this.companyId)
          .get()
          .then(doc => {
            let company = doc.data();
            this.logo = company.image;
          });
      })
      .catch(err => {
        console.log("Virhe", err);
      });
  },
  methods: {
    toggleNav(e) {
      e.stopPropagation();
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        window.addEventListener("click", () => {
          this.isOpen = false;
        });
      } else {
        window.removeEventListener("click", () => {
          this.isOpen = false;
        });
      }
    },
    toggleUserNav(e) {
      e.stopPropagation();
      this.userIsOpen = !this.userIsOpen;
      if (this.userIsOpen) {
        window.addEventListener("click", () => {
          this.userIsOpen = false;
        });
      } else {
        window.removeEventListener("click", () => {
          this.userIsOpen = false;
        });
      }
    },
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push({ name: "Login" });
        });
    }
  }
};
</script>

<style lang="scss">
.navbar-mobile {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 1em;
  height: 8rem;
  background: $lightred;
  box-shadow: $shadow_sm;
  z-index: 1;
  @include bp(lg) {
    display: none;
  }
  &__button {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: white;
    font-size: 1.6rem;
    font-family: $font;
  }
  &__close-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: auto;
    padding-right: 1em;
    color: $lightred;
    font-size: 1.6rem;
    font-family: $font;
  }
  &__menu {
    position: absolute;
    top: 0;
    left: 0;
    max-width: 25rem;
    width: 100%;
    height: 100%;
    padding: 1em 0;
    background: white;
    z-index: 999;
    box-shadow: $shadow_sm;
    border-top-right-radius: 1.5em;
    border-bottom-right-radius: 1.5em;
    z-index: 999;
    ul {
      padding: 1em 0;
      li {
        list-style-type: none;
        padding: 5px 1em;
        border-top: 1px solid $whitegray;
        &:last-child {
          border-bottom: 1px solid $whitegray;
        }
        &.router-link-exact-active {
          a {
            color: $lightred;
          }
        }
        a {
          text-decoration: none;
          color: black;
          font-size: 1.6rem;
        }
      }
    }
  }
  &__user-button {
    width: 4em;
    height: 4em;
  }
  &__user-logo {
    display: block;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 50%;
    box-shadow: $shadow_sm;
  }
  &__user-menu {
    position: absolute;
    top: 55px;
    right: 0;
    max-width: 15rem;
    width: 100%;
    padding: 1em;
    background: white;
    box-shadow: $shadow_sm;
    border-top-left-radius: 1.5em;
    border-bottom-left-radius: 1.5em;
    z-index: 999;
    ul {
      li {
        padding: 5px 0;
        list-style-type: none;
        text-align: center;
        a {
          text-decoration: none;
          color: black;
        }
      }
    }
  }
}
.hamburger {
  position: relative;
  display: block;
  width: 2em;
  height: 2px;
  margin-right: 1em;
  background: white;
  &:before,
  &:after {
    content: "";
    position: absolute;
    left: 0;
    width: 2em;
    height: 2px;
    background: white;
  }
  &:before {
    top: -7.5px;
  }
  &:after {
    top: 8.5px;
  }
}
.close {
  position: relative;
  right: 1em;
  width: 1em;
  height: 2px;
  background: $lightred;
  transform: rotate(135deg);
  &:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 1em;
    height: 2px;
    background: $lightred;
    transform: rotate(-90deg);
  }
}
.slide-left-enter-active {
  animation: slideLeft 0.25s ease-in-out;
}
.slide-left-leave-active {
  animation: slideLeft 0.25s reverse ease-in-out;
}
@keyframes slideLeft {
  0% {
    transform: translateX(-50em);
  }
  100% {
    transform: translateX(0);
  }
}
.slide-right-enter-active {
  animation: slideRight 0.25s ease-in-out;
}
.slide-right-leave-active {
  animation: slideRight 0.25s reverse ease-in-out;
}
@keyframes slideRight {
  0% {
    transform: translateX(50em);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
